<template>
  <b-modal
    ref="modal"
    size="xl"
    class="text-left "
    centered
    footer-class="justify-content-center"
    :visible="visible"
    ok-only
    ok-title="Close"
    @hidden="onModalHidden"
  >
    <template slot="modal-header">
      <div class="w-100">
        <h5 class="modal-title v2_info-popup__title text-center ">
          <span v-if="content && content.h1" v-html="content.h1" />
        </h5>
      </div>
    </template>
    <v-wait :for="contentLoaderName">
      <template slot="waiting">
        <HalfCircleSpinner />
        <div class="spinner-message my-3 text-center">
          Loading...
        </div>
      </template>
      <template v-if="isContent">
        <b-row class="mb-3">
          <b-col cols="12">
            <div v-if="content && content.p1" v-html="content.p1" />
          </b-col>
        </b-row>
      </template>
    </v-wait>
  </b-modal>
</template>

<script>
import { HalfCircleSpinner } from 'epic-spinners';
import Api from '@/providers/Api';
export default {
  name: 'IcoStudyFaqModal',
  components: {
    HalfCircleSpinner,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      content: null,
    };
  },
  created: function () {
    this.getContent();
  },
  computed: {
    contentLoaderName: function () {
      return this.$options.name + '_contentLoading';
    },
    isContent: function () {
      return this.content && Object.keys(this.content).length;
    },
  },
  methods: {
    onModalHidden: function () {
      this.$emit('modal-close');
    },
    getContent: async function () {
      this.$wait.start(this.contentLoaderName);
      try {
        this.content = await Api.getICOStudyFAQContent();
      } catch {
        this.$toasted.error(
          'Unable to update page content. Please try again later',
          { duration: 3000 }
        );
      } finally {
        this.$wait.end(this.contentLoaderName);
      }
    },
  },
};
</script>

<style scoped></style>
